import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const StarIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.54 3.11C11.71 2.699 12.29 2.699 12.46 3.11L14.41 7.795C14.55 8.142 14.88 8.378 15.25 8.408L20.31 8.814C20.76 8.849 20.94 9.403 20.6 9.692L16.74 12.993C16.46 13.237 16.33 13.62 16.42 13.985L17.6 18.921C17.7 19.353 17.23 19.695 16.85 19.464L12.52 16.818C12.2 16.623 11.8 16.623 11.48 16.818L7.148 19.464C6.768 19.695 6.298 19.353 6.401 18.921L7.578 13.985C7.665 13.62 7.541 13.237 7.256 12.993L3.402 9.692C3.065 9.403 3.244 8.849 3.688 8.814L8.75 8.408C9.12 8.378 9.45 8.142 9.59 7.795L11.54 3.11Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

StarIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(StarIcon);
